import workers_badge from 'asset/assistance-badge@2x.png';

export const data_assistance_banner = {
  image: workers_badge,
  title: `Need assistance?`,
  description: 'Ask a SoftServe expert at our demo station.',
};
